import { faClock, faLevelUpAlt, faStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Button from '@restart/ui/esm/Button';
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import courseData from '../../information.json'

export default function Details() {
    const { id } = useParams();
    const [course, setCourse] = useState({});

    useEffect(() => {
        setCourse(courseData.find(course => course.id === id))
    }, [id]);


    return (
        <div className="container mt-3">
            <div className="text-center">
                <img src={course.img} className="w-25" />
            </div>

            <h1 className="text-danger">
                Course Title: {course.title}
            </h1>
            <h3 className="text-primary">
                Price: {course.price}
            </h3>
            <span className="text-primary"> Course Instructor:</span> {course.instructor} <br />
            
            <div className="text-warning"><FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/> <FontAwesomeIcon icon={faStar}/></div>
            <FontAwesomeIcon icon={faClock} /> {course.duration} <br />
            <span className="text-primary">Level </span> {course.level} <br />
            <span className="text-primary">Platform: </span>{course.platform} <br />
            <span className="text-primary"> Total Enrolled : </span> {course.enrolled} <br />
            <span className="text-primary">Decription: </span>{course.details} <br />
            <Button className="btn btn-primary rounded">
                Enroll Now
            </Button>
        </div>
    )
}
